import React from 'react';
import { IconProps } from '../types';

export const ECommerceIcon = ({ color }: IconProps) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_8892_8406)">
            <rect width="32" height="32" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.15242 8.33325L12.8683 1.82931L11.1318 0.837158L6.84901 8.33325H0.333252V15.6666H2.99992V30.3333H12.9999V28.3333H4.99992V15.6666H31.6666V8.33325H25.1519L20.8682 0.837158L19.1318 1.82947L22.8484 8.33325H9.15242ZM29.6666 13.6666V10.3333H2.33325V13.6666H29.6666Z"
                fill={color}
            />
            <path
                d="M23.9999 19.6666C21.982 19.6666 20.2841 21.0469 19.803 22.9159L17.8661 22.4173C18.5691 19.6863 21.0472 17.6666 23.9999 17.6666C25.8904 17.6666 27.5862 18.4954 28.7457 19.8067L30.9599 18.1986L30.3892 24L24.6959 22.748L27.1168 20.9898C26.3279 20.173 25.2227 19.6666 23.9999 19.6666Z"
                fill={color}
            />
            <path
                d="M23.9999 29.6667C26.0179 29.6667 27.7158 28.2864 28.1968 26.4174L30.1337 26.9159C29.4307 29.647 26.9526 31.6667 23.9999 31.6667C22.1094 31.6667 20.4136 30.8378 19.2541 29.5265L17.04 31.1346L17.6106 25.3333L23.304 26.5852L20.8831 28.3435C21.6719 29.1603 22.7771 29.6667 23.9999 29.6667Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_8892_8406">
                <rect width="32" height="32" fill={color} />
            </clipPath>
        </defs>
    </svg>
);
